/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据id获取文章内容
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.Article;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/article/${id}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
